import { useCallback, useEffect, useState } from 'react';
import type { Setting } from '../models/Setting';
import { settingService } from '../services/dataverse/settingService';

export const useSettings = () => {
  const [settings, setSettings] = useState<Setting[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      setSettings(await settingService.list());
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Unable to load settings.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void reload();
  }, [reload]);

  const upsertSetting = useCallback(async (key: string, value: string, metadata?: Partial<Setting>) => {
    const updated = await settingService.upsert(key, value, metadata);
    await reload();
    return updated;
  }, [reload]);

  return { settings, loading, error, reload, upsertSetting };
};
